import classnames from 'classnames'
import { useSelector } from 'react-redux'
import { arrayOf, string, number, oneOfType, shape, bool } from 'prop-types'
import { Link } from 'react-router-dom'

// Selectors
import { selectCustomerId } from 'src/store/selectors/customerProfile'

// Components
import ListingCard from 'src/Components/homeSearch/ListingCard'
import { Text } from 'src/Components'

// Helpers
import { PATH_HELPERS } from 'src/constants/navigation'

// Styles
import styles from './SimilarHomes.module.scss'

const SimilarHomes = ({ listings, className, isSlim }) => {
  const customerId = useSelector(selectCustomerId)

  return (
    <div className={classnames(styles.similarHomesWrapper, className)}>
      <Text
        element='h2'
        size='l'
        className={styles.title}
        variant='neutralCool'
        variantCount='900'
        weight='bold'
        align='left'
      >
        Similar Homes
      </Text>
      <div
        className={classnames(
          styles.listingsWrapper,
          !isSlim && styles.notSlimLayout
        )}
      >
        {listings?.slice(0, isSlim ? 4 : 3).map(listing => (
          <div
            key={listing.id}
            className={
              isSlim ? styles.listingCardWrapperSlim : styles.listingCardWrapper
            }
          >
            <Link
              to={PATH_HELPERS.listing.buildPath(customerId, listing.id)}
              name={`listing_${listing.id}`}
            >
              <ListingCard
                listing={listing}
                allowFavorite={false}
                customerId={customerId}
                isSlim={isSlim}
                className={!isSlim && styles.fullWidthListingCard}
              />
            </Link>
          </div>
        ))}
      </div>
    </div>
  )
}

SimilarHomes.propTypes = {
  listings: arrayOf(
    shape({
      id: oneOfType([number, string]),
      mainPhoto: string,
      bedrooms: number,
      bathrooms: number,
      formattedPrice: string,
    })
  ),
  className: string,
  isSlim: bool,
}

export default SimilarHomes
